/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccessTokenDtoFromJSON, AccessTokenDtoToJSON, } from './AccessTokenDto';
/**
 * Check if a given object implements the MyPlaylistsRequestDto interface.
 */
export function instanceOfMyPlaylistsRequestDto(value) {
    return true;
}
export function MyPlaylistsRequestDtoFromJSON(json) {
    return MyPlaylistsRequestDtoFromJSONTyped(json, false);
}
export function MyPlaylistsRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'token': json['token'] == null ? undefined : AccessTokenDtoFromJSON(json['token']),
    };
}
export function MyPlaylistsRequestDtoToJSON(json) {
    return MyPlaylistsRequestDtoToJSONTyped(json, false);
}
export function MyPlaylistsRequestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'token': AccessTokenDtoToJSON(value['token']),
    };
}
